import { DestroyRef, inject, signal, Service } from '@angular/core';

export const MOBILE_PORTRAIT_QUERY = '(max-width: 992px)';

@Service()
export class MobilePortraitService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly mobilePortrait = signal(false);
  readonly isMobilePortrait = this.mobilePortrait.asReadonly();

  constructor() {
    if (
      typeof window === 'undefined' ||
      typeof window.matchMedia !== 'function'
    ) {
      return;
    }

    const mediaQuery = window.matchMedia(MOBILE_PORTRAIT_QUERY);
    const handleChange = (event: MediaQueryListEvent) => {
      this.mobilePortrait.set(event.matches);
    };

    this.mobilePortrait.set(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    this.destroyRef.onDestroy(() => {
      mediaQuery.removeEventListener('change', handleChange);
    });
  }
}
